import { AccountCircle, ContactPage } from "@mui/icons-material"
import { Avatar, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material"
import React from "react"
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../common/useProfile";


export default function MySpaceComp(props) {
    const {style} = props;
    const navigate = useNavigate();
    const prof = useProfile();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const menuId = 'my-space-cmp-id';

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    function handleMinhaPagina() {
        handleMenuClose();
        navigate("/minhaPagina");
    }
    function handleGotoPerfil(){
        handleMenuClose();
        navigate("/users/profile");
    }
    function handleGotoMyAccount(){
        handleMenuClose();
        navigate("/users/myAccount");
    }

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleGotoPerfil}>Perfil</MenuItem>
            <MenuItem onClick={handleGotoMyAccount}>Minha Conta</MenuItem>
            {prof.temAcesso("MinhaPagina") && <Divider />}
            {prof.temAcesso("MinhaPagina") && 
                <MenuItem onClick={handleMinhaPagina}>
                    <ListItemIcon >
                        <ContactPage fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Minha pagina</ListItemText>
                </MenuItem>}
        </Menu>
    )
    if (!prof.isOk)return;
    return (
        <React.Fragment>
            <Tooltip title='Minha Área'>
                <IconButton
                    size="small"
                    // edge="end"
                    aria-label="Minha area"
                    // aria-controls={menuId}
                    // aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    // sx={style != null? style:{ }}
                >
                    {prof.profile.avatar && 
                        <Avatar 
                            alt={prof.profile.nome} 
                            src={prof.profile.avatar}
                        />
                    }
                    {!prof.profile.avatar && <AccountCircle /> }
                </IconButton>
            </Tooltip>
            {renderMenu}
        </React.Fragment>
    )
}